<template>
  <div class="container-fluid job-preview">
    <div style="text-align: right !important;" class="row down-print">
      <router-link style="text-decoration: none !important;" :to="{name: 'candidateResumePreview',query: { job_id: jobID, cid: candidate_id, score: score}}" target="_blank">
        <div class="icon-class-save">
          <v-icon style="margin-bottom: -0.2rem"  size="24">mdi-printer</v-icon>
          <span style="margin-left: 1rem; font-size: 1.6rem">Workd Resume</span>
        </div>
      </router-link>
      <div style="margin-left: 1rem" v-if="!!d_key">
        <div @click="downloadResume" class="icon-class-view">
          <v-icon style="margin-bottom: -0.2rem"  size="24">mdi-download</v-icon>
          <span style="margin-left: 1rem; font-size: 1.6rem">Personal Resume</span>
        </div>
      </div>
    </div>
    <div ref="content">
      <div v-if="candidate" class="row preview-content-top">
        <div class="col-6 col-md-6 col-lg-4 col-xl-2 company-logo">
          <img :src="src" class="image" />
        </div>
        <div class="col-4 col-md-4 col-lg-6 col-xl-8 job-details-in-short">
          <div v-if="name" class="job-title">{{ name }}</div>
          <div v-if="position" class="company-name">{{ position }}</div>
          <div style="margin-top: 1rem; text-align: left">
            <span v-if="edu_ql">
              <v-icon
                size="16"
                style="color: #000000; margin-right: 0.5rem; margin-bottom: 0.1rem"
                >mdi-school</v-icon
              >{{ edu_ql }}
            </span>
            <span v-if="y_of_ex !== undefined">
              <v-icon
                size="16"
                style="color: #000000; margin-left: 0.5rem; margin-right: 0.2rem; margin-bottom: 0.1rem"
                >mdi-check-circle</v-icon
              >
              {{ y_of_ex }} year(s) of experience
            </span>
            <span v-if="location !== undefined">
              <v-icon
                size="16"
                style="color: #000000; margin-left: 0.5rem; margin-right: 0.2rem; margin-bottom: 0.1rem"
                >mdi-map-marker</v-icon
              >
              {{ location }}
            </span>
          </div>
          <div style="margin-top: 1rem; text-align: left">
            <span v-if="candidate.phone">
              <v-icon
                size="16"
                style="color: #000000; margin-right: 0.5rem; margin-bottom: 0.1rem"
              >mdi-phone</v-icon
              >{{ candidate.phone }}
            </span>
            <span v-if="candidate.email">
              <v-icon
                size="16"
                style="color: #000000; margin-left: 0.5rem; margin-right: 0.2rem; margin-bottom: 0.1rem"
              >mdi-email</v-icon
              >
              {{ candidate.email }}
            </span>
          </div>
        </div>
        <div
          v-if="!cvBank"
          class="col-2 col-md-2 col-lg-2 col-xl-2 job-details-in-short"
        >
          <div v-if="score >= 0">
            <v-progress-circular
              :rotate="-90"
              :size="100"
              :width="5"
              :value="score"
              :color="matchColor"
            >
              <span style="font-size: 2rem; font-weight: bold">{{
                score + "%"
              }}</span>
              <div style="font-size: 1.2rem; text-align: center">Match</div>
            </v-progress-circular>
          </div>
        </div>
      </div>
      <div v-if="experiences.length > 0" class="content">
        <div class="title-head">
          <span
            style="border-left: 2px solid #00adee; margin-right: 10px"
          ></span
          ><span>EXPERIENCE</span>
        </div>
        <div v-for="(experience, index) in experiences" :key="index">
          <experience
            :exp="experience"
            :ind="index"
            :end="experiences.length === index + 1"
          ></experience>
        </div>
      </div>
      <div v-if="educations.length > 0" class="content">
        <div class="title-head">
          <span
            style="border-left: 2px solid #00adee; margin-right: 10px"
          ></span
          ><span>EDUCATION</span>
        </div>
        <div v-for="(education, index) in educations" :key="index">
          <education
            :edu="education"
            :ind="index"
            :end="educations.length === index + 1"
          ></education>
        </div>
      </div>
      <div v-if="skills.length > 0" class="content" align="left">
        <div class="title-head">
          <span
            style="border-left: 2px solid #00adee; margin-right: 10px"
          ></span
          ><span>SKILL</span>
        </div>
        <div class="row skill-padding">
          <div
            v-bind:style="{ borderColor: getSkillColor(skill.skill_level) }"
            class="col-3 skill-chip"
            :key="index"
            v-for="(skill, index) in skills"
          >
            <div class="row">
              <div
                class="col-4 col-sm-2 col-md-2 col-lg-2 col-xl-2 no-padding"
                style="text-align: center; margin-top: 1rem"
              >
                <span
                  style="border: 1px solid #3d4249; border-radius: 50%; padding: 0.1rem 0.6rem"
                  >{{ index + 1 }}</span
                >
              </div>
              <div
                class="col-8 col-sm-10 col-md-10 col-lg-10 col-xl-10 no-padding"
              >
                <div style="font-weight: bold">{{ skill.skill_name }}</div>
                <div>{{ getSkillLevel(skill.skill_level) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="projects.length > 0" class="content">
        <div class="title-head">
          <span
            style="border-left: 2px solid #00adee; margin-right: 10px"
          ></span
          ><span>PROJECT</span>
        </div>
        <div v-for="(project, index) in projects" :key="index">
          <project
            :edu="project"
            :ind="index"
            :end="projects.length === index + 1"
          ></project>
        </div>
      </div>
      <div v-if="languages.length > 0" class="content no-border" align="left">
        <div class="title-head">
          <span
            style="border-left: 2px solid #00adee; margin-right: 10px"
          ></span
          ><span>LANGUAGE</span>
        </div>
        <div class="row skill-padding">
          <div
            class="col-2 no-padding"
            :key="index"
            v-for="(language, index) in languages"
          >
            <div class="row">
              <div
                class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 no-padding"
                style="text-align: center; margin-top: 0rem"
              >
                <span>
                  <v-icon size="40">mdi-chat-outline</v-icon>
                </span>
              </div>
              <div
                class="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 no-padding"
              >
                <div style="font-weight: bold">
                  {{ language.language_name }}
                </div>
                <div>{{ getLanguageLevel(language.language_level) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="training.length > 0" class="content">
        <div class="title-head">
          <span
            style="border-left: 2px solid #00adee; margin-right: 10px"
          ></span
          ><span>TRAINING</span>
        </div>
        <div v-for="(work, index) in training" :key="index">
          <div class="row" style="margin: 1rem 0 !important;">
            <div
              class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 no-padding"
              style="text-align: left; padding-left: 0.5rem !important; margin-top: 0.5rem"
            >
              <span class="num-wrapper">{{ index + 1 }}</span>
            </div>
            <div class="col-5 col-sm-5 col-md-5 col-lg-3 col-xl-3 exp-details">
              <div class="designation">{{ work.training_title }}</div>
              <div class="company">
                <div>{{ work.institution_name }}</div>
                <div v-if="work.location_name">
                  {{ ", " + work.location_name + "." }}
                </div>
                <div>{{ work.major_name }}</div>
                <div>
                  {{ work.training_year }}
                  <span>({{ work.training_duration + " Months" }})</span>
                </div>
              </div>
            </div>
            <div
              class="col-6 col-sm-6 col-md-6 col-lg-8 col-xl-8"
              style="text-align: left"
            >
              <div v-if="work.training_description" class="description">
                <span>{{ work.training_description }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="download"></div>
  </div>
</template>

<script>
// import * as SYSTEM_FUNCTIONS from "../../../globalFunctions";
import * as FILTERS from "../../../filters";
import { FIRST_LETTER_CAPITAL } from "../../../filters";
import Experience from "./experience";
import Education from "./education";
import Project from "./project";
import {SORT_PROFILE} from "../../../filters";
import {SORT_PROFILE_FORMAT2} from "../../../filters";
import {RESUME_ACTION} from "../../../Api/candidate_api";

export default {
  name: "candidate-details",
  components: {
    Experience,
    Education,
    Project
  },
  props: {
    candidate: Object,
    job_id: String,
    cvBank: Boolean
  },
  data: function() {
    return {
      test: true,
      name: null,
      score: null,
      gender: null,
      location: null,
      educations: [],
      experiences: [],
      skills: [],
      position: null,
      edu_ql: null,
      y_of_ex: null,
      src: require("@/assets/male_user.svg"),
      projects: [],
      languages: [],
      training: [],
      matchColor: "#055055",
      resumeObject: {},
      chnObj: 0,
      jobID: null,
      candidate_id: null,
      d_key: null,
      f_name: null
    };
  },
  methods: {
    downloadResume() {
      const self = this;
      let key = self.d_key;
      RESUME_ACTION(key, self.$constants.RESUME_ACTION.DOWNLOAD)
        .then(function(data) {
          const url = data.url;
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", self.f_name); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch(function(error) {
         alert(error)
        });
    },
    getSkillLevel(level) {
      switch (level) {
        case 1:
          return "Beginner";
        case 2:
          return "Intermediate";
        case 3:
          return "Professional";
        case 4:
          return "Advanced";
        case 5:
          return "Expert";
      }
    },
    getSkillColor(level) {
      switch (level) {
        case 1:
          return "#9c6bff";
        case 2:
          return "#8145ff";
        case 3:
          return "#133aff";
        case 4:
          return "#43a046";
        case 5:
          return "#2e7d31";
      }
    },
    getLanguageLevel(level) {
      switch (level) {
        case 1:
          return "Elementary";
        case 2:
          return "Limited Working";
        case 3:
          return "Professional Working";
        case 4:
          return "Full Professional";
        case 5:
          return "Native/Bilingual";
      }
    },
    printResume() {
      const self = this;
      let route = self.$router.resolve({
        name: "candidateResumePreview",
        params: { candidate: self.candidate }
      });
      window.open(route.href, "_blank");
    }
  },
  mounted: function() {
    const self = this;
    if (self.candidate) {
      self.jobID = self.job_id;
      self.candidate_id = self.candidate.user_id;
      self.name = FILTERS.FIRST_LETTER_CAPITAL(self.candidate.user_name);
      self.resumeObject.name = self.name;
      if (self.candidate.score !== undefined) {
        self.score = Math.round(self.candidate.score * 100);
        self.resumeObject.score = self.score;
        if (self.score > 75) {
          self.matchColor = self.$constants.SNACKBAR_COLOR.SUCCESS_ALT;
        } else if (self.score > 50) {
          self.matchColor = self.$constants.SNACKBAR_COLOR.SUCCESS;
        } else if (self.score > 25) {
          self.matchColor = self.$constants.SNACKBAR_COLOR.WARNING;
        } else {
          self.matchColor = self.$constants.SNACKBAR_COLOR.ERROR_ALT;
        }
      }
      if(!!self.candidate.download_key){
        self.d_key =  self.candidate.download_key
        self.f_name =  self.candidate.file_name
      }
      self.resumeObject.gender = self.gender = self.candidate.gender
        ? FILTERS.FIRST_LETTER_CAPITAL(self.candidate.gender)
        : null;
      if (self.gender === "female") {
        self.src = self.candidate.image_url
          ? self.candidate.image_url
          : require("@/assets/female_user.svg");
      } else {
        self.src = self.candidate.image_url
          ? self.candidate.image_url
          : require("@/assets/male_user.svg");
      }
      self.resumeObject.src = self.src;
      self.resumeObject.location = self.location = self.candidate.location_name
        ? FILTERS.FIRST_LETTER_CAPITAL(self.candidate.location_name)
        : null;
      if (self.candidate.company_name) {
        if (self.candidate.title) {
          self.resumeObject.position = self.position =
            FIRST_LETTER_CAPITAL(self.candidate.title) +
            " at " +
            FIRST_LETTER_CAPITAL(self.candidate.company_name);
        }
      }
      if (self.candidate.institution_name) {
        if (self.candidate.degree_name) {
          self.resumeObject.edu_ql = self.edu_ql =
            FIRST_LETTER_CAPITAL(self.candidate.degree_name) +
            ", " +
            FIRST_LETTER_CAPITAL(self.candidate.institution_name);
        }
      }
      if (self.candidate.year_of_exp !== undefined) {
        self.resumeObject.y_of_ex = self.y_of_ex = self.candidate.year_of_exp;
      }
      self.resumeObject.educations = self.educations = self.candidate.education
        ? SORT_PROFILE(self.candidate.education, "is_studying")
        : [];
      self.resumeObject.experiences = self.experiences
              = self.candidate.experience ? SORT_PROFILE_FORMAT2(self.candidate.experience, "is_working", [
        "start_year",
        "end_year"
      ]) : [];
      self.resumeObject.skills = self.skills = self.candidate.skill
        ? self.candidate.skill
        : "";
      self.resumeObject.projects = self.projects = self.candidate.projects
        ? SORT_PROFILE(self.candidate.projects, "is_working")
        : [];
      self.resumeObject.languages = self.languages = self.candidate.language
        ? self.candidate.language
        : "";
      self.resumeObject.training = self.training = self.candidate.training
        ? self.candidate.training.sort(function(a, b) {
                return b.training_year - a.training_year;
              })
        : [];
      self.chnObj++;
    }
  }
};
</script>

<style scoped>
.image {
  width: 18rem;
  height: 18rem;
  float: left;
}
.job-preview {
  padding: 1.5rem;
  position: relative;
}
.preview-content-top {
  padding: 1rem 0 1rem 0;
  border-bottom: 0.1rem dashed #3d4249;
  margin-top: 2rem !important;
}
.company-logo {
  padding: 0;
}
.job-details-in-short {
  padding: 0;
  margin-top: 4.5rem;
}
.job-title {
  font-size: 3rem;
  font-weight: bold;
  text-align: left;
  color: #050505;
}
.company-name {
  font-size: 1.6rem;
  text-align: left;
}
.company-email {
  font-size: 1.4rem;
  text-align: left;
}
.exp {
  font-size: 1.2rem;
}
.title-head {
  font-size: 1.8rem;
  font-weight: bold;
  padding: 1rem 0;
  text-align: left;
}
.content {
  padding: 1rem 0 2rem 0;
  border-bottom: 0.1rem solid #f0f0f0;
}
.button {
  background-color: #11998e;
  color: white;
  padding: 0.5rem;
  cursor: pointer;
}
.button-margin {
  margin-top: 4.5rem !important;
  margin-right: -7rem !important;
}
.no-border {
  border: 0rem;
}
.skill-padding {
  padding: 1rem;
}
.skill-chip {
  border: 1px solid #3555df;
  border-radius: 0.4rem;
  padding: 1rem !important;
  margin: 0.5rem !important;
}
.down-print {
  position: absolute;
  right: 1rem;
}
</style>
